// Thin wrapper around the shared typed client. The Clerk token source and the
// auth-fetch interceptor live in @my-app/shared so they stay in lock-step with
// the extension; only the worker origin (from this app's .env) is wired here.
export { setSessionTokenGetter } from '@my-app/shared';
import { createApiClient } from '@my-app/shared';
import { API_BASE_URL } from './config';

const { api, jobsApi, assessmentsApi } = createApiClient(API_BASE_URL);
export { api, jobsApi, assessmentsApi };
